import styled from '@emotion/styled';
import { COLOR, FONT_SIZE, FONT_WEIGHT } from '@ordermentum/ui-constants';

const Header = styled('div')`
  font-size: ${FONT_SIZE.XL};
  font-weight: ${FONT_WEIGHT.NORMAL};
  color: ${COLOR.ORANGE};
  text-align: center;
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 2rem;

  & > img {
    margin-top: 2rem;
  }
`;

const Animation = styled('img')`
  height: auto;
  width: ${p => p.width ?? '100%'};
`;

export { Header, Container, Animation };
